module.exports = __webpack_public_path__ + "static/media/youtube_orange.934bb037.svg";